/* eslint-disable */
import { store } from '../../store'
import { httpgst, http } from '../../main'

const actions = {
  get({ commit, dispatch }, payload) {
    const typeUser = payload.event.context.userLogged.roles[0].name
    const isCashier = payload.event.context.userLogged.cashier
    let params = {
      user_id: payload.event.user_id !== null ? payload.event.user_id : undefined,
      company_id: payload.event.company_id !== null ? payload.event.company_id : undefined,
      gst_expenses_status_id: payload.event.gst_expenses_status_id !== null ? payload.event.gst_expenses_status_id : undefined
    }
    let url = 'api/expenses-type-reservation'
    if (typeUser === 'EMPLOYEE' && isCashier) {
      url = 'api/cashier/expenses-created'
      params.type = 'EXPENSES'
    }
    let options = {
      emulateJSON: false,
      headers: { 'Content-Type': 'application/json' }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params }, options)
      .then(
        response => {
          commit('onGet', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  getReject({ commit, dispatch }, payload) {
    const typeUser = payload.event.context.userLogged.roles[0].name
    
    const isCashier = payload.event.context.userLogged.cashier
    
    let params = {
      user_id: payload.event.user_id !== null ? payload.event.user_id : undefined,
      company_id: payload.event.company_id !== null ? payload.event.company_id : undefined,
      gst_expenses_status_id: 1
    }

    let url = 'api/expenses-type-reservation'

    if (typeUser === 'EMPLOYEE' && isCashier) {
      url = 'api/cashier/expenses-created'
      params.type = 'EXPENSES'
    }

    let options = { emulateJSON: false, headers: { 'Content-Type': 'application/json' } }

    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token

    httpgst.get(url, { params }, options)
      .then(
        response => {
          commit('onGetReject', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  startWorkflow({ commit, dispatch }, payload) {
    let url = 'api/startWorkFlow/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, {}, {})
      .then(
        response => {
          commit('onStartWorkflow', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  users({ commit, dispatch }, payload) {
    let url = `api/user/by-company/${store.state.userLogged.company[0].id}?page=1&perPage=1000`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onUsers', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  projects({ commit, dispatch }, payload) {
    let url = 'api/projects/getProjects/' + store.state.userLogged.company[0].id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onProjects', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  async getCashierByCompany({ commit }, payload) {
    try {
      const url = 'api/cashier-by-company'
      const options = {
        emulateJSON: false,
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
      const response = await httpgst.get(url, {}, options)
      payload.event.event.context.cashiers = response.data.data
    } catch (error) {
      console.log(error.response);
    }
  },
  async getRelations({ commit }, { event }) {
    try {
      event.event.context.loadingRelation = true
      event.event.context.cashierRelation = []
      const url = `api/cashier-reservation/${event.event.cashier}`
      const options = {
        emulateJSON: false,
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
      const response = await httpgst.get(url, {}, options)

      if (response.data.data.length === 0) {
        event.event.context.showNotification('No se encontraron relaciones', 'error')
        return
      }

      event.event.context.cashierRelation = response.data.data[0].users.map(e => {
        return {
          user_id: e.user_id,
          name: e.name
        }
      })
    } catch (error) {
      console.log(error);
      event.event.context.showNotification(error.response, 'error')
    } finally {
      event.event.context.loadingRelation = false
    }
  },
  async deleteRelation({ commit }, { event }) {
    try {
      const url = `api/cashier-reservation/${event.event.cashier}?user_id=${event.event.user_id}`
      const options = {
        emulateJSON: false,
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
      const response = await httpgst.delete(url, {}, options)
      if(response.status !== 200) return event.event.context.showNotification(response.data.message, 'error')
      event.event.context.showNotification(response.data.message, 'success')
      event.event.context.closeDialogCashier()
    } catch (error) {
      console.log(error);
      event.event.context.showNotification(error.response, 'error')
    }
  },
  async generateRelations({ commit }, { event }) {
    try {
      const url = `api/cashier-reservation`
      const options = {
        emulateJSON: false,
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
      const response = await httpgst.post(url, event.event.payload, options)
      event.event.context.showNotification(response.data, 'success')
      event.event.context.$emit('getRelations', {
        event: {
          context: event.event.context,
          cashier: event.event.payload.cashier_id,
        },
      })
    } catch (error) {
      console.log(error);
      event.event.context.showNotification(error.response, 'error')
    }
  },
  async getUserRelationCashier({ commit }, payload) {
    try {

      const url = 'api/cashier-reservation-doesnt-user'
      const options = {
        emulateJSON: false,
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
      const response = await httpgst.get(url, {}, options)
      payload.event.event.context.cashiersUser = response.data.data
    } catch (error) {
      console.log(error);
      payload.event.context.showNotification(error.response, 'error')
    }
  }
}

const mutations = {
  onGet(state, payload) {
    let expenses = payload.response.data.data
    payload.event.context.expenses = expenses
    payload.event.context.loadingItems = false
  },
  onGetReject(state, payload) {
    let expenses = payload.response.data.data
    
    const filtrados = expenses.filter(expense => {
    
      const progressList = expense.expenses_progress;

    if (!progressList || progressList.length === 0) return false;

    // Obtener el progreso con ID más alto
    const ultimoProgreso = progressList.reduce((max, item) =>
          item.id > max.id ? item : max
        );

        // Validar que tenga status antes de usar toUpperCase()
        return ultimoProgreso.status && ultimoProgreso.status.toUpperCase() === 'REGRESADO';
      });


    payload.event.context.expenses = filtrados
    payload.event.context.loadingItems = false
  },
  onUsers(state, payload) {
    let employees = payload.response.data.data
    payload.event.context.employees = employees
  },
  onStartWorkflow(state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeWorkflowDialog()
    payload.event.context.refresh()
  },
  onProjects(state, payload) {
    let projects = payload.response.data.data
    payload.event.context.projects = projects
  },
  onError(state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reservations.js